package com.essntl.features.message.domain.useCase

import com.essntl.features.message.domain.repository.MessageRepository
import com.essntl.toastmanager.ToastManager
import org.koin.core.annotation.Single

@Single
class CheckSendContactUseCase(
    private val messageRepository: MessageRepository,
    private val toastManager: ToastManager,
) {
    suspend fun checkContact(
        contactId: String,
        onSuccess: () -> Unit,
        onFailure: () -> Unit,
    ) {
        messageRepository.checkContact(contactId)
            .onSuccess {
                onSuccess()
            }
            .onFailure {
                onFailure()
            }
    }

    suspend fun sendContact(
        to: String,
        onSuccess: () -> Unit,
        onFailure: () -> Unit,
    ) {
        messageRepository.sendContact(to)
            .onSuccess {
                onSuccess()
                toastManager.success(description = "Contact sent")
            }
            .onFailure {
                onFailure()
                toastManager.error(description = "Failed to send contact")
            }
    }
}